import { IVec2 } from "@base/math/Vec2";
import { PoleId, PoleIndex } from "@biz/definitions/SunSailDefinitions";
import { TriangleHelper } from "@biz/items/sunSail/logic/TriangleHelper";
import { TriangulationData } from "@biz/sc/sunSail/ISCSunSailData";

export class TriangulationHelper {
  static calcSandyCenterTriangulationPoint(cpt: { poleId: PoleId; distance: number; }[], points: IVec2[]): IVec2 | undefined {
    const target = TriangleHelper.calcPointForDistancesY2(points[cpt[0].poleId], points[cpt[1].poleId], cpt[0].distance, cpt[1].distance, true);
    if (!target)
      return undefined;

    return target;
  }
  static createInitialPoleTriangulationData(distance: number = 1): TriangulationData {
    return [
      { poleId: PoleIndex.A, distance },
      { poleId: PoleIndex.B, distance },
    ]
  }
}